const locations = {
  gothenburg: [57.705, 11.9],
  berlin: [52.575837, 13.383505],
  kopenhagen: [55.626188, 12.578228],
  paris: [48.86, 2.349014],
  munster: [51.961563, 7.628202],
}

export default locations
